module.exports = __webpack_public_path__ + "img/neckline length.ea27ebc1.png";